import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { type AxiosResponse } from "axios";
import { awsClientGateway } from "./common/gateway";
import { logMessage } from "../utils/amplifyLogger";
import { clientLog } from "./logging";

export const getCcpInitializedStatus = createAction<boolean>(
  "ccp/getCcpInitializedStatus",
);

export interface CcpAgentQueue {
  name: string;
  [key: string]: unknown;
}

export interface CcpRoutingProfile {
  name: string;
  queues: CcpAgentQueue[];
  [key: string]: unknown;
}

export interface CcpAgentConfiguration {
  name: string;
  username: string;
  routingProfile: CcpRoutingProfile;
  [key: string]: unknown;
}

export interface CcpAgentPayload {
  agentStatus: string;
  configuration: connect.AgentConfiguration;
  endpoints: connect.Endpoint[];
  [key: string]: unknown;
}
export const getCcpAgent = createAction<CcpAgentPayload>("ccp/getCcpAgent");

export interface CcpContactPayload {
  contactId: string | null;
  contactAttributes?: Record<string, { value: string }> | null;
  contactData?: unknown | null;
}
export const getCcpContact =
  createAction<CcpContactPayload>("ccp/getCcpContact");

export const getCcpOverlayStatus = createAction<boolean>(
  "ccp/getCcpOverlayStatus",
);

export interface CcpContactStatusPayload {
  status: string;
  method?: string;
}
export const getCcpContactStatus = createAction<CcpContactStatusPayload | null>(
  "ccp/getCcpContactStatus",
);

export const getCcpValidationButtonStatus = createAction<boolean>(
  "ccp/getCcpValidationButtonStatus",
);

export const getCcpCredentials = createAsyncThunk<
  AxiosResponse | undefined,
  string
>("ccp/credentials", async (instanceId: string) => {
  try {
    const queryParams = {
      instanceId: instanceId,
    };
    const response = await awsClientGateway({
      pathTemplate: "/credentials",
      method: "GET",
      queryParams,
    });
    if (!response) {
      throw new Error("ccp API reponse error");
    }
    return response;
  } catch (error) {
    clientLog({
      component: `ccp`,
      message: `Something went wrong in getCcpCredentials API => ${error}`,
    });
    logMessage(
      `ccp`,
      `Something went wrong in getCcpCredentials API => ${error}`,
      `error`,
    );
    return undefined;
  }
});
